import React from "react";
import { ArrowUpRightIcon } from "lucide-react";
import { useSeo, faqSchema } from "../hooks/useSeo";
import { Hero } from "../components/home/Hero";
import { TrustStrip } from "../components/home/TrustStrip";
import { IndustriesMarquee } from "../components/home/IndustriesMarquee";
import { ServicesIndex } from "../components/home/ServicesIndex";
import { FeaturedWork } from "../components/home/FeaturedWork";
import { DemoSection } from "../components/home/DemoSection";
import { WhyNexora } from "../components/home/WhyNexora";
import { TestimonialsSlider } from "../components/home/TestimonialsSlider";
import { ProcessTimeline } from "../components/process/ProcessTimeline";
import { PricingCards } from "../components/pricing/PricingCards";
import { SectionHeading } from "../components/ui/SectionHeading";
import { FaqAccordion } from "../components/ui/FaqAccordion";
import { CtaLink } from "../components/ui/CtaLink";
import { CtaBand } from "../components/ui/CtaBand";
import { HOME_FAQS } from "../data/faqs";
const schema = faqSchema(HOME_FAQS);
export function Home() {
  useSeo({
    title: "Home",
    description: "NEXORA Web Studio builds modern, professional websites for small businesses. One-time build from $600, hosting $75/mo, cancel anytime.",
    path: "/",
    schema
  });
  return <>
      <Hero data-id="element-732" data-mp="2mw8nbr2cvnlt" />
      <TrustStrip data-id="element-733" data-mp="2mwqpt5fm2y26" />
      <IndustriesMarquee data-id="element-734" data-mp="2mzcumxb4azgp" />
      <ServicesIndex data-id="element-735" data-mp="2hyfgcvt8apkh" />
      <FeaturedWork data-id="element-736" data-mp="2hyywc6zbj3vv" />
      <DemoSection data-id="element-737" data-mp="2hzi815ydkw1g" />
      <WhyNexora data-id="element-738" data-mp="2hzqjcteuntaj" />
      <section className="shell section" data-id="element-739" data-mp="2d7gwxncy1bd0">
        <SectionHeading align="split" eyebrow="Process" title="Four steps from idea to live." lead="You approve the design before we build and review the full site before launch." action={<CtaLink to="/process" variant="ghost" track="home_process_more" data-id="element-741" data-mp="236y6uauscymn">How we work <ArrowUpRightIcon className="h-4 w-4" data-id="element-742" data-mp="1z6weisaxxhk1" /></CtaLink>} data-id="element-740" data-mp="2d6fa6lmkf0fg" />
        <ProcessTimeline data-id="element-743" data-mp="1u82xipwg38f4" />
      </section>
      <section className="shell section border-t border-line" data-id="element-744" data-mp="1u94knsqqjld7">
        <SectionHeading align="split" eyebrow="Pricing" title="Two prices. No surprises." lead="A one-time build and optional monthly hosting & maintenance. That's it." action={<CtaLink to="/pricing" variant="ghost" track="home_pricing_more" data-id="element-746" data-mp="1ao434sw1brdi">Full pricing <ArrowUpRightIcon className="h-4 w-4" data-id="element-747" data-mp="1fkul5lregx1k" /></CtaLink>} data-id="element-745" data-mp="1kjnxhauyai05" />
        <PricingCards source="home" data-id="element-748" data-mp="23b8gbl5a7c0d" />
      </section>
      <TestimonialsSlider data-id="element-749" data-mp="23bqj70mg8oh9" />
      <section className="shell section grid gap-10 border-t border-line lg:grid-cols-[0.8fr_1.2fr]" data-id="element-750" data-mp="23dkstis9su61">
        <SectionHeading eyebrow="FAQ" title="Questions, answered." action={<CtaLink to="/resources/faq" variant="ghost" track="home_faq_all" data-id="element-752" data-mp="1tjkqfoodi310">All FAQs <ArrowUpRightIcon className="h-4 w-4" data-id="element-753" data-mp="1yixa60jy6tzd" /></CtaLink>} data-id="element-751" data-mp="28c4erj6v65ye" />
        <FaqAccordion items={HOME_FAQS} idPrefix="home-faq" data-id="element-754" data-mp="2m9t3j241xx8q" />
      </section>
      <CtaBand source="home" data-id="element-755" data-mp="2r0j84d4nlw2d" />
    </>;
}